"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asBodilessImage = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var components_1 = require("@bodiless/components");

var fclasses_1 = require("@bodiless/fclasses");

var ui_1 = require("@bodiless/ui");

var react_material_icon_1 = __importDefault(require("@material/react-material-icon"));

var withForwardedRefStart = function withForwardedRefStart(Component) {
  var WithForwardedRefStart = react_1.default.forwardRef(function (props, ref) {
    return react_1.default.createElement(Component, __assign({
      forwardedRef: ref
    }, props));
  });
  WithForwardedRefStart.displayName = 'WithForwardedRefStart';
  return WithForwardedRefStart;
};

var withForwardedRefEnd = function withForwardedRefEnd(Component) {
  var WithForwardedRefEnd = function WithForwardedRefEnd(_a) {
    var forwardedRef = _a.forwardedRef,
        rest = __rest(_a, ["forwardedRef"]);

    return react_1.default.createElement(Component, __assign({}, rest, {
      ref: forwardedRef
    }));
  };

  WithForwardedRefEnd.displayName = 'WithForwardedRefEnd';
  return WithForwardedRefEnd;
}; // Allows to pass a ref through a component to one of its children.
// @see: https://reactjs.org/docs/forwarding-refs.html


var withForwardedRef = function withForwardedRef() {
  var hocs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    hocs[_i] = arguments[_i];
  }

  return lodash_1.flowRight.apply(void 0, __spreadArrays([withForwardedRefStart], hocs, [withForwardedRefEnd]));
};

var MasterWrapper = fclasses_1.addClasses('bl-container')(fclasses_1.Section);
var Wrapper = lodash_1.flowRight(withForwardedRef(fclasses_1.addClasses('bl-min-h-grid-16 bl-border bl-border-dashed bl-border-grey-800 bl-bg-grey-100 bl-p-grid-3 bl-mb-grid-3 bl-text-black'), fclasses_1.stylable))('div');
var Input = withForwardedRef()('input');

var UploadArea = function UploadArea() {
  return react_1.default.createElement("div", {
    className: "bl-font-bold bl-text-base bl-text-center"
  }, "Drag a file or click here to upload.", react_1.default.createElement(react_material_icon_1.default, {
    className: "bl-w-full",
    icon: "cloud_upload"
  }));
};

var DragRejected = function DragRejected() {
  return react_1.default.createElement("div", {
    className: "bl-text-red"
  }, "File type not accepted or too many, try again!");
};

var UploadTimeout = function UploadTimeout() {
  return react_1.default.createElement("div", {
    className: "bl-text-red"
  }, "Upload failed, please try again.");
};

var Uploading = function Uploading() {
  return react_1.default.createElement(ui_1.Spinner, {
    color: "bl-bg-grey-800 bl-my-4"
  });
};

var UploadFinished = function UploadFinished() {
  return react_1.default.createElement("div", {
    className: "bl-text-center bl-text-lg bl-text-black"
  }, "Done!");
};

var UploadStatus = function UploadStatus(_a) {
  var statusText = _a.statusText;
  return react_1.default.createElement("div", null, statusText);
};

var imagePickerUI = {
  MasterWrapper: MasterWrapper,
  Wrapper: Wrapper,
  Input: Input,
  UploadArea: UploadArea,
  Uploading: Uploading,
  DragRejected: DragRejected,
  UploadTimeout: UploadTimeout,
  UploadFinished: UploadFinished,
  UploadStatus: UploadStatus
};

var withUI = function withUI(ui) {
  return fclasses_1.addProps({
    ui: ui
  });
};

var asBodilessImage = function asBodilessImage(nodeKey, defaultData, useOverrides) {
  return lodash_1.flowRight(withUI(imagePickerUI), components_1.asBodilessImage(nodeKey, defaultData, useOverrides), core_1.withoutProps(['ui']));
};

exports.asBodilessImage = asBodilessImage;
var Image = asBodilessImage()(fclasses_1.Img);
exports.default = Image;